import { useCreateProductServiceAdminAxiosInstance } from "../Auth/useCreateProductServiceAdminAxiosInstance.ts";
import useSWR from "swr";

export function useKnownPurchaseAcTags(item: "products" | "bundles") {
  const { createAxiosInstance } = useCreateProductServiceAdminAxiosInstance();
  const url = `/${item}/ac-tags/known-purchase-tags`;
  const { isLoading, data } = useSWR(url, async (url) => {
    const { data } = await createAxiosInstance().get<string[]>(url);
    return data;
  });

  return {
    purchaseTags: data ?? [],
    isLoading,
  };
}
